var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoogleIcon = function SvgGoogleIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0929 7.61569C16.1851 8.10994 16.2354 8.62669 16.2354 9.16594C16.2354 13.3839 13.4124 16.3832 9.14862 16.3832C8.17899 16.3835 7.2188 16.1927 6.32292 15.8218C5.42704 15.4509 4.61303 14.907 3.9274 14.2214C3.24176 13.5358 2.69795 12.7218 2.32702 11.8259C1.95609 10.93 1.76533 9.96982 1.76563 9.00019C1.76533 8.03056 1.95609 7.07037 2.32702 6.17449C2.69795 5.27861 3.24176 4.46459 3.9274 3.77896C4.61303 3.09333 5.42704 2.54951 6.32292 2.17858C7.2188 1.80766 8.17899 1.61689 9.14862 1.61719C11.1421 1.61719 12.8079 2.35069 14.0859 3.54169L12.0046 5.62294V5.61769C11.2299 4.87969 10.2466 4.50094 9.14862 4.50094C6.71262 4.50094 4.73263 6.55894 4.73263 8.99569C4.73263 11.4317 6.71262 13.4942 9.14862 13.4942C11.3589 13.4942 12.8634 12.2304 13.1724 10.4949H9.14862V7.61569H16.0936H16.0929Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/googleIcon.88ac3c75.svg";
export { ForwardRef as ReactComponent };